import React from "react";

const Home = () => {

    return (
        <div className='w-full bg-bgBlack pt-28 pb-14 px-6 flex flex-col items-center' id='home'>

            <div className='w-full max-w-5xl flex flex-col-reverse lg:flex-row items-center gap-8 lg:gap-14'>
                <div className='flex-1 flex flex-col items-center lg:items-start text-center lg:text-left'>
                    <p className='text-sbPallet-accent font-bold uppercase tracking-widest text-sm'>Health &amp; Performance Coach</p>

                    <h1 className='mt-3 text-3xl md:text-5xl font-black uppercase leading-tight'>
                        Mejora tu físico. <br/> Mejora tu salud.
                    </h1>

                    <p className='mt-4 text-white/70 max-w-md'>
                        Entrenamiento y nutrición individualizados para conseguir resultados reales y sostenibles.
                    </p>

                    {/* Bloque de experiencia oculto temporalmente
                    <div className='mt-8 flex flex-wrap justify-center lg:justify-start gap-x-8 gap-y-4'>
                        <div className='text-center lg:text-left'>
                            <p className='text-2xl font-black text-sbPallet-accent'>+20</p>
                            <p className='text-[11px] uppercase tracking-wide text-white/60'>Años de experiencia</p>
                        </div>
                        <div className='text-center lg:text-left'>
                            <p className='text-2xl font-black text-sbPallet-accent'>2009</p>
                            <p className='text-[11px] uppercase tracking-wide text-white/60'>Online desde</p>
                        </div>
                        <div className='text-center lg:text-left'>
                            <p className='text-2xl font-black text-sbPallet-accent'>+1.000</p>
                            <p className='text-[11px] uppercase tracking-wide text-white/60'>Transformaciones</p>
                        </div>
                    </div>
                    */}

                    <p className='mt-8 text-xs uppercase tracking-widest text-white/50 font-bold'>Plazas limitadas cada mes</p>

                    <a href='#cambio'
                       className='mt-4 w-full max-w-[280px] py-4 px-6 bg-sbPallet-accent hover:bg-white hover:text-sbPallet-accent rounded-lg text-lg font-bold uppercase flex items-center justify-center ease-in duration-100'>
                        Reservar mi plaza
                    </a>
                </div>

                <div className='flex-1 w-full max-w-md lg:max-w-none'>
                    <img className='w-full aspect-[5/7] rounded-2xl object-cover object-[60%_center]'
                         src="/assets/transformaciones/portada-raul.jpeg"
                         alt="Raúl Pérez"/>
                </div>
            </div>
        </div>
    )
}

export default Home
